import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import { EjariApi } from "@eres/ejari-api";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import ListGridDataView from "@my-dld/components/DataView/ListGridDataView";
import { MCRequest } from "@eres/ejari-api/Entity/management_contract";
import MgmContractRequestsListView from "../../../component/ManagementContract/MgmContractRequestsListView";
import MgmContractRequestsGridView from "../../../component/ManagementContract/MgmContractRequestsGridView";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import _ from "lodash";

interface State {
	isLoading: boolean;
	requests: MCRequest[];
}

interface Props extends RoutedViewProps {
}

class ManagementContractRequests extends Component<Props, State> {
	constructor( props: RoutedViewProps ) {
		super( props );
		this.state = {
			isLoading: true,
			requests: [],
		};
	}

	componentDidMount(): void {
		this.loadTerminationRequests();
	}

	render() {
		const { isLoading, requests } = this.state;
		return <ListGridDataView
			isLoading={ isLoading }
			dataAvailable={ requests.length > 0 }
			title={ Strings.management_contract_requests }
			renderListView={ this.renderListView }
			renderGridView={ this.renderGridView }/>;
	}

	private renderListView = () => {
		const { requests } = this.state;
		return <MgmContractRequestsListView items={ requests }/>;
	};

	private renderGridView = () => {
		const { requests } = this.state;
		return <MgmContractRequestsGridView items={ requests }/>;
	};

	private loadTerminationRequests() {
		EjariApi.getManagementContract()
		.then( ( resp ) => {
			this.handleResponse( resp );
		} ).catch( reason => {
			showErrorMessage( reason );
			this.handleResponse( { TerminationRequests: [] } );
		} );
	}

	private handleResponse( resp: any ) {
		const requests = _.orderBy( resp.TerminationRequests, "TerminationDate", "desc" );
		this.setState( {
			requests: requests,
			isLoading: false,
		} );
	}
}

export default ManagementContractRequests;
